import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IBreadCrumb } from "../models/breadcrumb.model";

@Injectable({
    providedIn: 'root'
})
export default class BreadcrumbService {

    constructor() {
    }

    buildBreadCrumb(route: ActivatedRoute,
        url: string = '',
        breadcrumbs: IBreadCrumb[] = []): IBreadCrumb[] {

        let label = route.routeConfig && route.routeConfig.data ?
            route.routeConfig.data['breadcrumb'] : '';
        let path = route.routeConfig && route.routeConfig.data ?
            route.routeConfig.path : '';

        const lastRoutePart = path.split('/').pop();
        const isDynamicRoute = lastRoutePart.startsWith(':');

        if (isDynamicRoute && !!route.snapshot) {
            const paramName = lastRoutePart.split(':')[1];
            path = path.replace(lastRoutePart, route.snapshot.params[paramName]);
            label = route.snapshot.params[paramName];
        }

        const nextUrl = path ? `${url}/${path}` : url;

        const breadcrumb: IBreadCrumb = {
            label: label,
            url: nextUrl
        }

        const newBreadcrumbs = breadcrumb.label ? [...breadcrumbs, breadcrumb] :
            [...breadcrumbs];

        if (route.firstChild) {
            return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
        }
        return newBreadcrumbs;
    }
}